import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isOpen: false
};
const sessionSlice = createSlice({
    name: 'healthMonitor',
    initialState,
    reducers: {
        handleIsOpen: (state, action) => {
            state.isOpen = action.payload;
        }
    }
});
export const { handleIsOpen, } = sessionSlice.actions;
export default sessionSlice.reducer;
